/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TableModule } from '../models/TableModule';
import type { UpdateTableModulesRequest } from '../models/UpdateTableModulesRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TableModulesService {

    /**
     * Retrieve all scores for the specified organization.
     * @param organizationId The ID of the organization to scope the table module for.
     * @param tableModuleId The ID of the table module to update.
     * @param requestBody The request to update the table module.
     * @returns TableModule OK
     * @throws ApiError
     */
    public static updateTableModules(
        organizationId: string,
        tableModuleId?: string,
        requestBody?: UpdateTableModulesRequest,
    ): CancelablePromise<TableModule> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tablemodules/{organizationId}/TableModuleId',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'tableModuleId': tableModuleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all scores for the specified organization.
     * @param organizationId The ID of the organization to scope the table module for.
     * @param description The description of the table module.
     * @returns TableModule OK
     * @throws ApiError
     */
    public static getTableModules(
        organizationId: string,
        description: string,
    ): CancelablePromise<TableModule> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tablemodules/{organizationId}/{description}',
            path: {
                'organizationId': organizationId,
                'description': description,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
